/**
 * Sine and cosine from Bhaskara I's rational approximation, `+ - * /` only (D-020), so lookup
 * tables built from them are bit-identical on every JS engine. Absolute error < 0.0017.
 * Used at track compile time, never per tick.
 */

/** Bhaskara I on `[0, 180]` degrees. */
function bhaskara(deg: number): number {
  const q = deg * (180 - deg)
  return (4 * q) / (40500 - q)
}

/** Sine of an angle in degrees, any range. Odd and 360-periodic by construction. */
export function sinDeg(deg: number): number {
  let d = deg % 360
  if (d < 0) d += 360
  return d <= 180 ? bhaskara(d) : -bhaskara(d - 180)
}

/** Cosine of an angle in degrees, any range. */
export function cosDeg(deg: number): number {
  return sinDeg(deg + 90)
}
